import React, {useEffect, useState} from 'react';
import {useFetchPaymentOptionsQuery} from 'components/customer/Confirmation/store/gatewayApi';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';
import {useAppDispatch} from 'store/dashboard';
import {
    isLoadingMiscSet,
    miscDataSet,
    selectAmountPaid,
    selectNewJobTotal,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {Row, Item} from 'components/customer/Confirmation/Checkout/Table';
import {formatPrice} from 'shared/helpers';
import {useAppSelector} from 'store/customer';
import styled from 'styled-components';

export const Misc = () => {
    const dispatch = useAppDispatch();
    const {job} = useJobContext() as PartialJob;
    const {data} = useFetchPaymentOptionsQuery(
        {jobID: job.id},
        {skip: job && job?.id == undefined}
    );
    const [showMisc, setShowMisc] = useState(false);

    const newJobTotal = useAppSelector(selectNewJobTotal);
    const amountPaid = useAppSelector(selectAmountPaid);

    useEffect(() => {
        if (data) {
            const {fullAmount, initialJobTotal, netPaid, overpaidAmount} =
                data.paymentSummary;
            const miscData = {
                newJobTotal: fullAmount,
                amountPaid: netPaid,
                overPaid: overpaidAmount > 0,
            };

            if (fullAmount != initialJobTotal && netPaid > 0) {
                dispatch(miscDataSet(miscData));
                setShowMisc(true);
            }

            dispatch(isLoadingMiscSet(false));
        }
    }, [data]);

    if (showMisc) {
        return (
            <>
                {newJobTotal ? (
                    <Row>
                        <td>
                            <Item>Job Total</Item>
                        </td>
                        <td>
                            <strong>{formatPrice(newJobTotal || 0, {})}</strong>
                        </td>
                        <td />
                    </Row>
                ) : null}

                {amountPaid ? (
                    <Row>
                        <td>
                            <Item>Paid</Item>
                        </td>
                        <td>
                            <GreenStrong>
                                -{formatPrice(amountPaid || 0, {})}
                            </GreenStrong>
                        </td>
                        <td />
                    </Row>
                ) : null}
            </>
        );
    }
};

const GreenStrong = styled.strong`
    color: green;
`;
